import { Pipe, PipeTransform } from '@angular/core';
import { NativeIntegrationService } from '../services/native-integration.service';
import { BridgeMode } from '@hg-com/xwc-js-bridge/dist/native-app.service';
import { Md5 } from 'ts-md5';

/**
 * Dies ist eine Angular Pipe mit dem Namen "ImagePipe", die eine Transformation auf einem Stringwert durchführt.
 *
 *   In der Transformationsfunktion wird zuerst die Dateiendung extrahiert (fileSuffix), um später eine neue URL mit dem gleichen Suffix zu generieren. Dann wird geprüft, ob eine Native-Integration vorhanden ist und ob sich die Anwendung im Offline-Modus befindet. Wenn dies der Fall ist, wird eine neue URL generiert, indem ein MD5-Hash des ursprünglichen Stringwerts berechnet und an den Media-Endpoint der XWC-Server-URL angehängt wird. Andernfalls wird einfach der ursprüngliche Stringwert zurückgegeben, der eine URL zu einem Bild darstellt.
 *
 *   Insgesamt ermöglicht dieser Pipe also die dynamische Generierung von URLs zu Bildern, die sich je nach Kontext der Anwendung ändern können.
 */

@Pipe({
  name: 'image',
})
export class ImagePipe implements PipeTransform {
  constructor(private nis: NativeIntegrationService) {}

  transform(value: string): string {
    const md5 = new Md5();
    const fileSuffix = value.substr(value.length - 3);
    if (
      this.nis.native.mode > BridgeMode.Mock &&
      this.nis.offlineMode$.getValue()
    ) {
      return (`http://localhost:${this.nis.native.port}/xwc/pack/latest/media/` +
        md5.appendStr(value).end() +
        '.' +
        fileSuffix) as string;
    } else {
      return value;
    }
  }
}
